/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React, { useEffect } from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"
import { useLocation } from "@reach/router"
function SeoResult({ description, lang, meta, title, county }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description
  const defaultTitle = site.siteMetadata?.title
  const { pathname } = useLocation();
  var curentUrl = process.env.GATSBY_SITE_URL; 
  if (county) {
    curentUrl = process.env.GATSBY_SITE_URL + '/' + pathname.split('/')[1] + '/' + pathname.split('/')[2] + '/in-' + county.replace(/ /gi, '-').toLowerCase()
  } else {
    curentUrl = process.env.GATSBY_SITE_URL + '/' + pathname.split('/')[1] + '/' + pathname.split('/')[2] + '/' + pathname.split('/')[3];
  }
  if (!curentUrl.endsWith('/'))  
    curentUrl = curentUrl + '/';

  //remove multiple slashes
  curentUrl = curentUrl.replace(/([^:]\/)\/+/g, "$1");
  //set lowercase url
  curentUrl = curentUrl.toLowerCase();

  useEffect(()=>{
    if(pathname){
      localStorage.setItem('searchResultPath', pathname);
    }
  },[pathname])

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={defaultTitle ? `%s | ${defaultTitle}` : null}
      link={[
        {
          href: curentUrl,
          rel: "canonical"
        }
      ]}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
            property: `og:url`,
            content: curentUrl,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata?.author || ``,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
        {
          name: `google-signin-client_id`,
          content: '497182326454-kfh4i6pb7b1mg3c1m9qnhop28mmat9gm.apps.googleusercontent.com',
        },
      ].concat(meta)}
    />
  )
}

SeoResult.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

SeoResult.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default SeoResult
